import { createSlice } from '@reduxjs/toolkit';

type DrawerState = {
  state: 'open' | 'closed';
};

const drawerSlice = createSlice({
  name: 'drawer',
  initialState: {
    state: 'closed',
  } as DrawerState,

  reducers: {
    open: (draft) => {
      draft.state = 'open';
    },

    close: (draft) => {
      draft.state = 'closed';
    },
  },

  selectors: {
    state: (state: DrawerState) => state.state,

    isOpen: (state: DrawerState) => state.state === 'open',
    isClosed: (state: DrawerState) => state.state === 'closed',
  },
});

export const actions = drawerSlice.actions;
export const selectors = drawerSlice.selectors;

export default drawerSlice.reducer;
